import React from 'react';
import ContentBlockDefault from './ContentBlockDefault';
import ContentBlockFullWidth from './ContentBlockFullWidth';

export default function ContentBlock({ data, id }) {
  const { title, paragraphs, image, imageOnRight, grayBackground, fullsizeImage } = data;
  if (fullsizeImage) {
    return (
      <ContentBlockFullWidth
        grayBackground={grayBackground}
        imageOnRight={imageOnRight}
        paragraphs={paragraphs}
        title={title}
        image={image}
        id={id}
      />
    );
  }
  return (
    <ContentBlockDefault
      grayBackground={grayBackground}
      imageOnRight={imageOnRight}
      paragraphs={paragraphs}
      title={title}
      image={image}
      id={id}
    />
  );
}
